import { Col, Row } from 'react-bootstrap'
import { useOrganization } from '../context/OrganizationContext'
import { useText } from '../context/TextContext'
import { Deal } from '../models/shared/Deal'
import { useFirebaseDoc } from '../hooks/firebaseHooks'
import { COLLECTIONS } from '../utils/shared/constants'
import { Customer } from '../models/shared/Customer'
import OrganizationLogo from './OrganizationLogo'
import CustomerCard from './CustomerCard'

interface Props {
    deal: Deal;
    showPaymentInstructions?: boolean;
}

/**
 * Shared seller (organization) + buyer (customer) card, used by both the
 * Offer org/customer block and the Invoice editor/public view.
 */
export default function OrgCustomerCard({ deal, showPaymentInstructions }: Props) {
    const { organization, orgId } = useOrganization();
    const text = useText();
    const [customer] = useFirebaseDoc<Customer>(deal.customerId
        ? `${COLLECTIONS.ORGANIZATIONS}/${orgId}/${COLLECTIONS.CUSTOMERS}/${deal.customerId}`
        : undefined);
    const orgName = organization.name || '';

    return (
        <div className="org-customer-block">
            <Row className="g-4">
                <Col xs={12} md={6}>
                    <div className="offer-profile">
                        <div className='position-relative'>
                            <img className='bg' src="/assets/profile-seller-bg.jpg" alt="" />
                            <OrganizationLogo logo={organization.logo} size="sm" readonly={true} className='profile-logo' />
                        </div>

                        <div className='details p-3'>
                            <strong>{text.seller}</strong>
                            {orgName && <div className='text-line'>
                                <i className="bi bi-building" />
                                {orgName}
                            </div>}

                            {organization.email && (
                                <div className="text-line">
                                    <i className="bi bi-envelope"></i>
                                    <a href={`mailto:${organization.email}`}>{organization.email}</a>
                                </div>
                            )}

                            {organization.place && (
                                <div className="text-line">
                                    <i className="bi bi-geo-alt"></i>
                                    <div>{organization.place.name || organization.place.formattedAddress}</div>
                                </div>
                            )}

                            {organization.website && (
                                <div className="text-line">
                                    <i className="bi bi-globe"></i>
                                    <a href={organization.website} target="_blank" rel="noopener noreferrer">
                                        {organization.website}
                                    </a>
                                </div>
                            )}

                            {showPaymentInstructions && organization.settings?.paymentInstructions && (
                                <div className="text-line align-items-start">
                                    <i className="bi bi-credit-card"></i>
                                    <div style={{ whiteSpace: 'pre-wrap' }}>{organization.settings.paymentInstructions}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </Col>

                <Col xs={12} md={6}>
                    <CustomerCard customer={customer} noCustomerText />
                </Col>
            </Row>
        </div>
    );
}
